export const environment = {
    production: true,
    apiURL: 'https://test.thelaboratorymatters.com',
    RAZORPAY_KEY_ID: 'rzp_test_SXqDMkC2aJMRXL',
};
